module.exports = __webpack_public_path__ + "img/setup.cd845722.png";